import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { notifySelector, notifySlice } from 'Modules'
import { useAppDispatch } from 'Src/hooks'
import { NotifyWrapper } from './styled'

const actions = {
	close: notifySlice.actions.removeNotify,
}
export const NotifyComponent = () => {
	const notification = useSelector(notifySelector.getNotification)
	const { close } = useAppDispatch(actions)

	useEffect(() => {
		const intervalId = setTimeout(() => {
			close()
		}, 2000)

		return () => {
			clearInterval(intervalId)
		}
	}, [notification])

	return <>{notification && <NotifyWrapper>{notification.title}</NotifyWrapper>}</>
}
